import {Injectable} from "@angular/core";
import {ApiService} from "./api.service";
import {endpoints} from "../../../../environments/endpoints";
import {Observable} from "rxjs";
import {SiteModel} from "../../../models/site.model";
import {DefaultResponse} from "../../../interfaces/responses";
import {UnityModel} from "../../../models/unity.model";

@Injectable({
    providedIn: "root"
})
export class SitesService {
    constructor(private _apiService: ApiService) {
    }

    getSites(): Observable<DefaultResponse<SiteModel[]>> {
        return this._apiService.get(endpoints.sites);
    }

    getSiteUnities(siteId: string): Observable<DefaultResponse<UnityModel[]>> {
        return this._apiService.get(`${endpoints.sites}/${siteId}/unities`);
    }

    create(data: { label: string }): Observable<DefaultResponse<SiteModel>> {
        return this._apiService.post<DefaultResponse<SiteModel>, { label: string }>(`${endpoints.sites}`, data);
    }

    update(id: string, data: { label: string }): Observable<DefaultResponse<SiteModel>> {
        return this._apiService.patch<DefaultResponse<SiteModel>, { label: string }>(`${endpoints.sites}/${id}`, data);
    }

    delete(id: string): Observable<DefaultResponse<any>> {
        return this._apiService.delete<DefaultResponse<any>>(`${endpoints.sites}/${id}`);
    }
}
